<template>
  <div class="recordTemplate">
    <h4 class="heading">Add Records for the following Patient Types
    </h4>
    <el-row>
      <el-form label-position="top" ref="addRecordsForm" @submit.prevent.native :model="addRecords">
        <el-col class="contentSpacing" :span="24">
          <el-collapse v-if="recordSet" v-loading="loading" element-loading-spinner="nucleus-loader" id="reviewCollapse"
            v-model="activeNames" @change="toggleCollapse">
            <el-collapse-item v-if="reviewRequest.reviewType.find(x => x === 'Acute')" title="Inpatient" name="1">
              <template slot="title">
                <el-col :span="12" style="padding-left: 0px;">
                  Inpatient
                </el-col>
                <el-col :span="12" style="text-align: right; padding: 0px 15px 0px 0px;">
                  {{(this.addRecords.records[this.ipIndex].records) > 0 ? `${(this.addRecords.records[this.ipIndex].records)} Records` : ''}}
                </el-col>
              </template>
              <el-col class="collapseContentLeft" :span="7">
                <span>HIA will validate:</span>
                <ul class="hiaValidation">
                  <li v-for="item in getReviewValidations('IP')" :key="item.id">{{item.description}}</li>
                </ul>
                <el-button :disabled="(addRecords.records[ipIndex].records) === 0" plain
                  style="margin: 15px 0px 0px 0px;" @click="clearPatientType(ipIndex)">
                  Clear Records <i style="padding-left: 5px;" class="mdi mdi-book-multiple-minus reviewIcon"></i>
                </el-button>
              </el-col>
              <el-col class="collapseContentLeft" :span="17">
                <el-form label-position="top" ref="ipRecords">
                  <el-row>
                    <el-col style="padding-right: 10px;" :span="24">
                      <el-form-item :label="addValidations">
                        <el-form-item>
                          <el-checkbox style="display: block;" v-model="addRecords.records[ipIndex].poa"
                            @change="addReviewRecords('ip')">All POA Indicators<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                        <el-form-item>
                          <el-checkbox style="display: block;" v-model="addRecords.records[ipIndex].aprDrg"
                            @change="addReviewRecords('ip')">APR-DRG<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                        <el-form-item>
                          <el-checkbox style="display: block;" v-model="addRecords.records[ipIndex].level2"
                            @change="addReviewRecords('ip')">Level 2<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                      </el-form-item>
                      <el-form-item label="Number of Records:" class="topPadding">
                        <el-input-number v-model="addRecords.records[ipIndex].records" :min="0"
                          @change="addReviewRecords('ip')">
                        </el-input-number>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col style="padding: 10px 10px 0px 0px;" :span="24">
                      <el-form-item label="Special Instructions">
                        <el-input type="textarea" :rows="4" placeholder="Instructions"
                          v-model="addRecords.records[ipIndex].instructions" @change="addReviewRecords('ip')">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-collapse-item>
            <el-collapse-item v-if="reviewRequest.reviewType.find(x => x === 'Acute')" title="DRG Validation" name="2">
              <template slot="title">
                <el-col :span="12" style="padding-left: 0px;">
                  DRG Validation
                </el-col>
                <el-col :span="12" style="text-align: right; padding: 0px 15px 0px 0px;">
                  {{(this.addRecords.records[this.drgIndex].records) > 0 ? `${(this.addRecords.records[this.drgIndex].records)} Records` : ''}}
                </el-col>
              </template>
              <el-col class="collapseContentLeft" :span="7">
                <span>HIA will validate:</span>
                <ul class="hiaValidation">
                  <li v-for="item in getReviewValidations('DRG')" :key="item.id">{{item.description}}</li>
                </ul>
                <el-button :disabled="(addRecords.records[drgIndex].records) === 0" plain
                  style="margin: 15px 0px 0px 0px;" @click="clearPatientType(drgIndex)">
                  Clear Records <i style="padding-left: 5px;" class="mdi mdi-book-multiple-minus reviewIcon"></i>
                </el-button>
              </el-col>
              <el-col class="collapseContentLeft" :span="17">
                <el-form label-position="top" ref="ipRecords">
                  <el-row>
                    <el-col style="padding-right: 10px;" :span="24">
                      <el-form-item :label="addValidations">
                        <el-form-item>
                          <el-checkbox style="display: block;" v-model="addRecords.records[drgIndex].aprDrg"
                            @change="addReviewRecords('drg')">APR-DRG<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                        <el-form-item>
                          <el-checkbox style="display: block;" v-model="addRecords.records[drgIndex].level2"
                            @change="addReviewRecords('drg')">Level 2<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                      </el-form-item>
                      <el-form-item label="Number of Records:">
                        <el-input-number v-model="addRecords.records[drgIndex].records" :min="0"
                          @change="addReviewRecords('drg')">
                        </el-input-number>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col style="padding: 10px 10px 0px 0px;" :span="24">
                      <el-form-item label="Special Instructions">
                        <el-input type="textarea" :rows="4" placeholder="Instructions"
                          v-model="addRecords.records[drgIndex].instructions" @change="addReviewRecords('drg')">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-collapse-item>
            <el-collapse-item v-if="reviewRequest.reviewType.find(x => x === 'Acute')" title="Ambulatory Surgery"
              name="3">
              <template slot="title">
                <el-col :span="12" style="padding-left: 0px;">
                  Ambulatory Surgery
                </el-col>
                <el-col :span="12" style="text-align: right; padding: 0px 15px 0px 0px;">
                  {{(this.addRecords.records[this.ascIndex].records) > 0 ? `${this.addRecords.records[this.ascIndex].records} Records` : ''}}
                </el-col>
              </template>
              <el-col class="collapseContentLeft" :span="7">
                <span>HIA will validate:</span>
                <ul class="hiaValidation">
                  <li v-for="item in getReviewValidations('ASC')" :key="item.id">{{item.description}}</li>
                </ul>
                <el-button :disabled="(addRecords.records[ascIndex].records) === 0" plain
                  style="margin: 15px 0px 0px 0px;" @click="clearPatientType(ascIndex)">
                  Clear Records <i style="padding-left: 5px;" class="mdi mdi-book-multiple-minus reviewIcon"></i>
                </el-button>
              </el-col>
              <el-col class="collapseContentLeft" :span="17">
                <el-form label-position="top" ref="ascRecords">
                  <el-row>
                    <el-col style="padding-right: 10px;" :span="24">
                      <el-form-item class="subMargin" :label="addValidations">
                        <el-checkbox style="display: block;" v-model="addRecords.records[ascIndex].includePCS"
                          @change="addReviewRecords('asc')">{{pcsCodes}}<span class="additionalPricing">*</span>
                        </el-checkbox>
                      </el-form-item>
                      <el-form-item label="Number of Records:">
                        <el-input-number v-model="addRecords.records[ascIndex].records" :min="0"
                          @change="addReviewRecords('asc')">
                        </el-input-number>
                      </el-form-item>

                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col style="padding: 10px 10px 0px 0px;" :span="24">
                      <el-form-item label="Special Instructions:">
                        <el-input type="textarea" :rows="4" placeholder="Instructions"
                          v-model="addRecords.records[ascIndex].instructions" @change="addReviewRecords('asc')">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-collapse-item>
            <el-collapse-item v-if="reviewRequest.reviewType.find(x => x === 'Acute')" title="Observation" name="4">
              <template slot="title">
                <el-col :span="12" style="padding-left: 0px;">
                  Observation
                </el-col>
                <el-col :span="12" style="text-align: right; padding: 0px 15px 0px 0px;">
                  {{(this.addRecords.records[this.obsIndex].records) > 0 ? `${this.addRecords.records[this.obsIndex].records} Records` : ''}}
                </el-col>
              </template>
              <el-col class="collapseContentLeft" :span="7">
                <span>HIA will validate:</span>
                <ul class="hiaValidation">
                  <li v-for="item in getReviewValidations('OBS')" :key="item.id">{{item.description}}</li>
                </ul>
                <el-button :disabled="(addRecords.records[obsIndex].records) === 0" plain
                  style="margin: 15px 0px 0px 0px;" @click="clearPatientType(obsIndex)">
                  Clear Records <i style="padding-left: 5px;" class="mdi mdi-book-multiple-minus reviewIcon"></i>
                </el-button>
              </el-col>
              <el-col class="collapseContentLeft" :span="17">
                <el-form label-position="top" ref="obsRecords">
                  <el-row>
                    <el-col style="padding-right: 10px;" :span="24">
                      <el-form-item :label="addValidations">
                        <el-form-item>
                          <el-checkbox style="display: block;" v-model="addRecords.records[obsIndex].ii"
                            @change="addReviewRecords('obs')">{{iiCodes}}<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                        <el-form-item>
                          <el-checkbox style="display: block;" v-model="addRecords.records[obsIndex].includePCS"
                            @change="addReviewRecords('obs')">{{pcsCodes}}<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                      </el-form-item>
                      <h4 class="reviewHeading">Records:</h4>
                      <el-form-item label="Number of Records:" class="topPadding">
                        <el-input-number v-model="addRecords.records[obsIndex].records" :min="0"
                          @change="addReviewRecords('obs')">
                        </el-input-number>
                      </el-form-item>
                      <el-form-item class="subMargin">

                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col style="padding: 10px 10px 0px 0px;" :span="24">
                      <el-form-item label="Special Instructions:">
                        <el-input type="textarea" :rows="4" placeholder="Instructions"
                          v-model="addRecords.records[obsIndex].instructions" @change="addReviewRecords('obs')">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-collapse-item>
            <el-collapse-item v-if="reviewRequest.reviewType.find(x => x === 'Acute')" title="Ancillary" name="5">
              <template slot="title">
                <el-col :span="12" style="padding-left: 0px;">
                  Ancillary
                </el-col>
                <el-col :span="12" style="text-align: right; padding: 0px 15px 0px 0px;">
                  {{(this.addRecords.records[this.ancIndex].records) > 0 ? `${this.addRecords.records[this.ancIndex].records} Records` : ''}}
                </el-col>
              </template>
              <el-col class="collapseContentLeft" :span="7">
                <span>HIA will validate:</span>
                <ul class="hiaValidation">
                  <li v-for="item in getReviewValidations('ANC')" :key="item.id">{{item.description}}</li>
                </ul>
                <el-button :disabled="(addRecords.records[ancIndex].records) === 0" plain
                  style="margin: 15px 0px 0px 0px;" @click="clearPatientType(ancIndex)">
                  Clear Records <i style="padding-left: 5px;" class="mdi mdi-book-multiple-minus reviewIcon"></i>
                </el-button>
              </el-col>
              <el-col class="collapseContentLeft" :span="17">
                <el-form label-position="top" ref="ancRecords">
                  <el-row>
                    <el-col style="padding-right: 10px;" :span="24">
                      <el-form-item :label="addValidations">
                        <el-form-item>
                          <el-checkbox style="display: block;" v-model="addRecords.records[ancIndex].em"
                            @change="addReviewRecords('anc')">Facility E&M?<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                        <el-form-item>
                          <el-checkbox style="display: block;" v-model="addRecords.records[ancIndex].ii"
                            @change="addReviewRecords('anc')">{{iiCodes}}<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                        <el-form-item>
                          <el-checkbox style="display: block;" v-model="addRecords.records[ancIndex].recurringRecords"
                            @change="addReviewRecords('anc')">Will
                            any
                            of these be recurring records?
                          </el-checkbox>
                        </el-form-item>
                        <el-form-item v-if="addRecords.records[ancIndex].recurringRecords"
                          label="Specified type of Recurring Account:" style="padding-left: 5%;">
                          <el-input placeholder="Physicial Therapy, Chemotherapy, Wound Care..."
                            v-model="addRecords.records[ancIndex].recurringAccount" @change="addReviewRecords('anc')">
                          </el-input>
                          <small><i>*Reminder we will validate one date of service for each recurring
                              account</i></small>
                        </el-form-item>
                      </el-form-item>
                      <el-form-item label="Number of Records:" class="topPadding">
                        <el-input-number v-model="addRecords.records[ancIndex].records" :min="0"
                          @change="addReviewRecords('anc')">
                        </el-input-number>
                      </el-form-item>
                      <el-form-item class="subMargin">
                        <el-checkbox style="display: block;" v-model="addRecords.records[ancIndex].includePCS"
                          @change="addReviewRecords('anc')">Include PCS?<span style="margin: 0px 0px 0px 5px;"
                            title="Additional Pricing">*</span>
                        </el-checkbox>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col style="padding: 10px 10px 0px 0px;" :span="24">
                      <el-form-item
                        label="Please explain if any of these charts will include procedures or if you have special instructions:">
                        <el-input type="textarea" :rows="4" placeholder="Instructions"
                          v-model="addRecords.records[ancIndex].instructions" @change="addReviewRecords('anc')">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-collapse-item>
            <el-collapse-item v-if="reviewRequest.reviewType.find(x => x === 'Acute')" title="Emergency Room" name="6">
              <template slot="title">
                <el-col :span="12" style="padding-left: 0px;">
                  Emergency Room
                </el-col>
                <el-col :span="12" style="text-align: right; padding: 0px 15px 0px 0px;">
                  {{(this.addRecords.records[this.edIndex].records + this.addRecords.records[this.edIndex].facility + this.addRecords.records[this.edIndex].professional + this.addRecords.records[this.edIndex].both) > 0 ? `${(this.addRecords.records[this.edIndex].records + this.addRecords.records[this.edIndex].facility + this.addRecords.records[this.edIndex].professional + this.addRecords.records[this.edIndex].both)} Records` : ''}}
                </el-col>
              </template>
              <el-col class="collapseContentLeft" :span="7">
                <span>HIA will validate:</span>
                <ul class="hiaValidation">
                  <li v-for="item in getReviewValidations('ED')" :key="item.id">{{item.description}}</li>
                </ul>
                <el-button
                  :disabled="(addRecords.records[edIndex].records + addRecords.records[edIndex].facility + addRecords.records[edIndex].professional + addRecords.records[edIndex].both) === 0"
                  plain style="margin: 15px 0px 0px 0px;" @click="clearPatientType(edIndex)">
                  Clear Records <i style="padding-left: 5px;" class="mdi mdi-book-multiple-minus reviewIcon"></i>
                </el-button>
              </el-col>
              <el-col class="collapseContentLeft" :span="17">
                <el-form label-position="top" ref="edRecords">
                  <el-row>
                    <el-col style="padding-right: 10px;" :span="24">
                      <el-form-item :label="addValidations">
                        <el-form-item class="topPadding">
                          <el-checkbox style="display: block;" v-model="addRecords.records[edIndex].ii"
                            @change="addReviewRecords('ed')">{{iiCodes}}<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                        <el-form-item class="topPadding">
                          <el-checkbox style="display: block;" v-model="addRecords.records[edIndex].includePCS"
                            @change="addReviewRecords('ed')">{{pcsCodes}}<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                      </el-form-item>
                      <el-form-item class="topPadding">
                          <el-checkbox style="display: block;" v-model="addRecords.records[edIndex].em"
                            @change="addReviewRecords('ed')">Include Facility EM<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                        <el-form-item class="topPadding">
                          <el-checkbox style="display: block;" v-model="addRecords.records[edIndex].proem"
                            @change="addReviewRecords('ed')">Include Professional EM<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                        <el-form-item label="Number of Records:" class="topPadding">
                        <el-input-number v-model="addRecords.records[edIndex].records" :min="0"
                          @change="addReviewRecords('ed')">
                        </el-input-number>
                      </el-form-item>
                      <!-- <el-form-item label="Number of Records without EM:" class="topPadding">
                        <el-input-number v-model="addRecords.records[edIndex].records" :min="0"
                          @change="addReviewRecords('ed')">
                        </el-input-number>
                      </el-form-item>
                      <el-form-item label="Number of Facility EM:" class="topPadding">
                        <el-input-number v-model="addRecords.records[edIndex].facility" :min="0"
                          @change="addReviewRecords('ed')">
                        </el-input-number>
                      </el-form-item>
                      <el-form-item label="Number of Professional EM:" class="topPadding">
                        <el-input-number v-model="addRecords.records[edIndex].professional" :min="0"
                          @change="addReviewRecords('ed')">
                        </el-input-number>
                      </el-form-item>
                      <el-form-item label="Number of Both (Facility and Professional):" class="topPadding">
                        <el-input-number v-model="addRecords.records[edIndex].both" :min="0"
                          @change="addReviewRecords('ed')">
                        </el-input-number>
                      </el-form-item> -->

                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col style="padding: 15px 10px 0px 0px;" :span="24">
                      <el-form-item label="Special Instructions:">
                        <el-input type="textarea" :rows="4" placeholder="Instructions"
                          v-model="addRecords.records[edIndex].instructions" @change="addReviewRecords('ed')">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-collapse-item>
            <el-collapse-item v-if="reviewRequest.reviewType.find(x => x === 'Acute')" title="Interventional Procedures"
              name="7">
              <template slot="title">
                <el-col :span="12" style="padding-left: 0px;">
                  Interventional Procedures
                </el-col>
                <el-col :span="12" style="text-align: right; padding: 0px 15px 0px 0px;">
                  {{(this.addRecords.records[this.irIndex].records) > 0 ? `${this.addRecords.records[this.irIndex].records} Records` : ''}}
                </el-col>
              </template>
              <el-col class="collapseContentLeft" :span="7">
                <span>HIA will validate:</span>
                <ul class="hiaValidation">
                  <li v-for="item in getReviewValidations('IR')" :key="item.id">{{item.description}}</li>
                </ul>
                <el-button :disabled="(addRecords.records[irIndex].records) === 0" plain
                  style="margin: 15px 0px 0px 0px;" @click="clearPatientType(irIndex)">
                  Clear Records <i style="padding-left: 5px;" class="mdi mdi-book-multiple-minus reviewIcon"></i>
                </el-button>
              </el-col>
              <el-col class="collapseContentLeft" :span="17">
                <el-form label-position="top" ref="irRecords">
                  <el-row>
                    <el-col style="padding-right: 10px;" :span="24">
                      <el-form-item :label="addValidations">
                        <el-form-item>
                          <el-checkbox style="display: block;" v-model="addRecords.records[irIndex].si"
                            @change="addReviewRecords('ir')">{{siCodes}}<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                        <el-form-item>
                          <el-checkbox style="display: block;" v-model="addRecords.records[irIndex].includePCS"
                            @change="addReviewRecords('ir')">{{pcsCodes}}<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                      </el-form-item>
                      <el-form-item label="Number of Records:" class="topPadding">
                        <el-input-number v-model="addRecords.records[irIndex].records" :min="0"
                          @change="addReviewRecords('ir')">
                        </el-input-number>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col style="padding: 10px 10px 0px 0px;" :span="24">
                      <el-form-item label="Special Instructions:">
                        <el-input type="textarea" :rows="4" placeholder="Instructions"
                          v-model="addRecords.records[irIndex].instructions" @change="addReviewRecords('ir')">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-collapse-item>
            <el-collapse-item v-if="reviewRequest.reviewType.find(x => x === 'Acute')" title="Wound Care" name="8">
              <template slot="title">
                <el-col :span="12" style="padding-left: 0px;">
                  Wound Care
                </el-col>
                <el-col :span="12" style="text-align: right; padding: 0px 15px 0px 0px;">
                  {{(this.addRecords.records[this.wcIndex].records) > 0 ? `${this.addRecords.records[this.wcIndex].records} Records` : ''}}
                </el-col>
              </template>
              <el-col class="collapseContentLeft" :span="7">
                <span>HIA will validate:</span>
                <ul class="hiaValidation">
                  <li v-for="item in getReviewValidations('WC')" :key="item.id">{{item.description}}</li>
                </ul>
                <el-button :disabled="(addRecords.records[wcIndex].records) === 0" plain
                  style="margin: 15px 0px 0px 0px;" @click="clearPatientType(wcIndex)">
                  Clear Records <i style="padding-left: 5px;" class="mdi mdi-book-multiple-minus reviewIcon"></i>
                </el-button>
              </el-col>
              <el-col class="collapseContentLeft" :span="17">
                <el-form label-position="top" ref="wcRecords">
                  <el-row>
                    <el-col style="padding-right: 10px;" :span="24">
                      <el-form-item :label="addValidations">
                        <el-form-item>
                          <el-checkbox style="display: block;" v-model="addRecords.records[wcIndex].em"
                            @change="addReviewRecords('wc')">E/M Coding<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                        <el-form-item>
                          <el-checkbox style="display: block;" v-model="addRecords.records[wcIndex].ii"
                            @change="addReviewRecords('wc')">{{iiCodes}}<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                      </el-form-item>
                      <el-form-item>
                        <el-checkbox style="display: block;" v-model="addRecords.records[wcIndex].includePCS"
                          @change="addReviewRecords('wc')">{{pcsCodes}}<span class="additionalPricing">*</span>
                        </el-checkbox>
                      </el-form-item>
                      <el-form-item>
                        <el-checkbox style="display: block;" v-model="addRecords.records[wcIndex].recurringRecords"
                          @change="addReviewRecords('wc')">Will any
                          of these be recurring records?
                        </el-checkbox>
                      </el-form-item>
                      <el-form-item v-if="addRecords.records[wcIndex].recurringRecords"
                        label="Specified type of Recurring Account:" style="padding-left: 5%;">
                        <el-input placeholder="Physicial Therapy, Chemotherapy, Wound Care..."
                          v-model="addRecords.records[wcIndex].recurringAccount" @change="addReviewRecords('wc')">
                        </el-input>
                        <small><i>*Reminder we will validate one date of service for each recurring account</i></small>
                      </el-form-item>
                      <el-form-item label="Number of Records:" class="topPadding">
                        <el-input-number v-model="addRecords.records[wcIndex].records" :min="0"
                          @change="addReviewRecords('wc')">
                        </el-input-number>
                      </el-form-item>

                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col style="padding: 10px 10px 0px 0px;" :span="24">
                      <!-- <el-alert show-icon :closable="false" title="" type="info"
                      description='HIA charges per encounter and typically, HIA reviews the first encounter in the record. Should you wish to change this, please note in the "Special instructions" field below.'>
                    </el-alert> -->
                      <small><i>*HIA charges per encounter and typically, HIA reviews the first encounter in the record.
                          Should you wish to change this, please note in the "Special instructions" field
                          below.</i></small>
                      <el-form-item
                        label="Please explain if any of these charts will include procedures or if you have special instructions:">
                        <el-input type="textarea" :rows="4" placeholder="Instructions"
                          v-model="addRecords.records[wcIndex].instructions" @change="addReviewRecords('wc')">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-collapse-item>
            <el-collapse-item v-if="reviewRequest.reviewType.find(x => x === 'Acute')" title="Pain Management" name="9">
              <template slot="title">
                <el-col :span="12" style="padding-left: 0px;">
                  Pain Management
                </el-col>
                <el-col :span="12" style="text-align: right; padding: 0px 15px 0px 0px;">
                  {{(this.addRecords.records[this.pmIndex].records) > 0 ? `${this.addRecords.records[this.pmIndex].records} Records` : ''}}
                </el-col>
              </template>
              <el-col class="collapseContentLeft" :span="7">
                <span>HIA will validate:</span>
                <ul class="hiaValidation">
                  <li v-for="item in getReviewValidations('PM')" :key="item.id">{{item.description}}</li>
                </ul>
                <el-button :disabled="(addRecords.records[pmIndex].records) === 0" plain
                  style="margin: 15px 0px 0px 0px;" @click="clearPatientType(pmIndex)">
                  Clear Records <i style="padding-left: 5px;" class="mdi mdi-book-multiple-minus reviewIcon"></i>
                </el-button>
              </el-col>
              <el-col class="collapseContentLeft" :span="17">
                <el-form label-position="top" ref="pmRecords">
                  <el-row>
                    <el-col style="padding-right: 10px;" :span="24">
                      <el-form-item :label="addValidations">
                        <el-form-item>
                          <el-checkbox style="display: block;" v-model="addRecords.records[pmIndex].em"
                            @change="addReviewRecords('pm')">Facility E&M?<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                        <el-form-item>
                          <el-checkbox style="display: block;" v-model="addRecords.records[pmIndex].ii"
                            @change="addReviewRecords('pm')">{{iiCodes}}<span class="additionalPricing">*</span>
                          </el-checkbox>
                        </el-form-item>
                      </el-form-item>
                      <el-form-item>
                        <el-checkbox style="display: block;" v-model="addRecords.records[pmIndex].includePCS"
                          @change="addReviewRecords('pm')">{{pcsCodes}}<span class="additionalPricing">*</span>
                        </el-checkbox>
                      </el-form-item>
                      <el-form-item>
                        <el-checkbox style="display: block;" v-model="addRecords.records[pmIndex].recurringRecords"
                          @change="addReviewRecords('pm')">Will any
                          of these be recurring records?
                        </el-checkbox>
                      </el-form-item>
                      <el-form-item v-if="addRecords.records[pmIndex].recurringRecords"
                        label="Specified type of Recurring Account:" style="padding-left: 5%;">
                        <el-input placeholder="Physicial Therapy, Chemotherapy, Wound Care..."
                          v-model="addRecords.records[pmIndex].recurringAccount" @change="addReviewRecords('pm')">
                        </el-input>
                        <small><i>*Reminder we will validate one date of service for each recurring account</i></small>
                      </el-form-item>
                      <el-form-item label="Number of Records:" class="topPadding">
                        <el-input-number v-model="addRecords.records[pmIndex].records" :min="0"
                          @change="addReviewRecords('pm')">
                        </el-input-number>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col style="padding: 10px 10px 0px 0px;" :span="24">
                      <!-- <el-alert show-icon :closable="false" title="" type="info"
                      description='HIA charges per encounter and typically, HIA reviews the first encounter in the record. Should you wish to change this, please note in the "Special instructions" field below.'>
                    </el-alert> -->
                      <small><i>*HIA charges per encounter and typically, HIA reviews the first encounter in the record.
                          Should you wish to change this, please note in the "Special instructions" field
                          below.</i></small>
                      <el-form-item
                        label="Please explain if any of these charts will include procedures or if you have special instructions:">
                        <el-input type="textarea" :rows="4" placeholder="Instructions"
                          v-model="addRecords.records[pmIndex].instructions" @change="addReviewRecords('pm')">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-collapse-item>
            <el-collapse-item v-if="reviewRequest.reviewType.find(x => x === 'Acute')" title="Other" name="10">
              <template slot="title">
                <el-col :span="12" style="padding-left: 0px;">
                  Other
                </el-col>
                <el-col :span="12" style="text-align: right; padding: 0px 15px 0px 0px;">
                  {{(this.addRecords.records[this.otherIndex].records) > 0 ? `${this.addRecords.records[this.otherIndex].records} Records` : ''}}
                </el-col>
              </template>
              <el-col class="collapseContentLeft" :span="7">
                <span>HIA will validate:</span>
                <ul class="hiaValidation">
                  <li>TBD</li>
                </ul>
                <el-button :disabled="(addRecords.records[otherIndex].records) === 0" plain
                  style="margin: 15px 0px 0px 0px;" @click="clearPatientType(otherIndex)">
                  Clear Records <i style="padding-left: 5px;" class="mdi mdi-book-multiple-minus reviewIcon"></i>
                </el-button>
              </el-col>
              <el-col class="collapseContentLeft" :span="17">
                <el-form label-position="top" ref="otherRecords">
                  <el-row>
                    <el-col style="padding-right: 10px;" :span="24">
                      <el-form-item label="Number of Records:">
                        <el-input-number v-model="addRecords.records[otherIndex].records" :min="0"
                          @change="addReviewRecords('other')">
                        </el-input-number>
                      </el-form-item>
                      <el-form-item class="subMargin">
                        <el-checkbox style="display: block;" v-model="addRecords.records[otherIndex].includePCS"
                          @change="addReviewRecords('other')">Include PCS?<span style="margin: 0px 0px 0px 5px;"
                            title="Additional Pricing">*</span>
                        </el-checkbox>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col style="padding: 10px 10px 0px 0px;" :span="24">
                      <el-form-item label="Please describe patient type and/or service(s) to be reviewed:">
                        <el-input type="textarea" :rows="4" placeholder="Sevices Instructions"
                          v-model="addRecords.records[otherIndex].serviceInstructions"
                          @change="addReviewRecords('other')">
                        </el-input>
                      </el-form-item>
                      <el-form-item
                        label="Please explain if any of these charts will include procedures or if you have special instructions:"
                        class="topPadding">
                        <el-input type="textarea" :rows="4" placeholder="Instructions"
                          v-model="addRecords.records[otherIndex].instructions" @change="addReviewRecords('other')">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-collapse-item>
            <ReviewRequestProRecordDetails ref="proRecordDetails"
              v-if="reviewRequest.reviewType.find(x => x === 'Professional Fee')" :reviewRequest="reviewRequest"
              :addRecords="addRecords" :loading="loading" @toggleProSelectedBy="toggleProSelectedBy"
              @clearPro="clearPro" @addProRecords="addProRecords">
            </ReviewRequestProRecordDetails>
          </el-collapse>
        </el-col>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="4">
        <el-button v-if="this.$route.path.includes('new')" :disabled="totalReviewRecords() <= 0" plain
          style="width: 157px;margin: 8px 0px 0px 0px;" @click="clearAllPatientType()">
          Clear All Records <i style="padding-left: 5px;" class="mdi mdi-book-multiple-minus reviewIcon"></i>
        </el-button>&nbsp;
      </el-col>
      <el-col :span="16" style="text-align: right; padding-right: 20px;">
        <p class="totalRecords">Total Records: {{totalReviewRecords()}}</p>
      </el-col>
      <el-col :span="4"></el-col>
    </el-row>
  </div>
</template>
<script>

  import ReviewRequestProRecordDetails from './ReviewRequestProRecordDetails'
  import { mapState } from 'vuex'

  export default {
    props: {
      loading: {
        type: Boolean
      },
      reviewRequest: {
        type: Object
      }
    },
    data: function () {
      return {
        patientTypes: [
          { type: 'ip', title: 'Inpatient' },
          { type: 'drg', title: 'DRG Validation' },
          { type: 'asc', title: 'Ambulatory Surgery' },
          { type: 'obs', title: 'Observation' },
          { type: 'anc', title: 'Ancillary' },
          { type: 'ed', title: 'Emergency Room' },
          { type: 'ir', title: 'Interventional Procedures' },
          { type: 'wc', title: 'Wound Care' },
          { type: 'pm', title: 'Pain Management' },
          { type: 'other', title: 'Other' }
        ],
        recordSet: false,
        activeNames: [],
        fetchingReviewValidations: false,
        addRecords: {
          location: 'remote',
          dateRange: [],
          focus: '',
          reviewType: ['Acute'],
          proRecords: {
            type: 'pro',
            title: 'Professional Fee',
            instructions: '',
            records: []
          },
          records: []
        },
        ipIndex: 0,
        drgIndex: 0,
        ascIndex: 0,
        obsIndex: 0,
        ancIndex: 0,
        edIndex: 0,
        irIndex: 0,
        wcIndex: 0,
        pmIndex: 0,
        otherIndex: 0,
        addValidations: 'Additional Validations (*Add-On Fees May Apply)',
        pcsCodes: 'PCS Codes',
        iiCodes: 'Injection and Infusion codes',
        siCodes: 'S&I Codes (70000 - 90000 CPT Range)'
      }
    },
    name: 'ReviewRequestAcuteRecordDetails',
    methods: {
      toggleCollapse(collapseItem) {
        // console.log(collapseItem)
      },
      toggleProSelectedBy() {
        this.$emit('toggleProSelectedBy')
      },
      addReviewRecords(patientType) {
        this.$emit('addRecords', { requestId: this.$route.params.id, patientType: patientType, records: this.addRecords.records })
      },
      clearPatientType(index) {
        this.addRecords.records[index].comprehensiveRecords = 0
        this.addRecords.records[index].aprDrg = false
        this.addRecords.records[index].poa = false
        this.addRecords.records[index].level2 = false
        this.addRecords.records[index].drgRecords = 0
        this.addRecords.records[index].instructions = null
        this.addRecords.records[index].comprehensiveRecords = 0
        this.addRecords.records[index].aprDrg = false
        this.addRecords.records[index].poa = false
        this.addRecords.records[index].level2 = false
        this.addRecords.records[index].drgRecords = 0
        this.addRecords.records[index].instructions = null
        this.addRecords.records[index].includePCS = false
        this.addRecords.records[index].records = 0
        this.addRecords.records[index].em = false
        this.addRecords.records[index].ii = false
        this.addRecords.records[index].recurringRecords = false
        this.addRecords.records[index].recurringAccount = null
        this.addRecords.records[index].facility = 0
        this.addRecords.records[index].professional = 0
        this.addRecords.records[index].both = 0
        this.addRecords.records[index].si = false
        this.addRecords.records[index].serviceInstructions = null
        this.addRecords.records[index].proem = false
        this.$emit('clearRecords', { requestId: this.$route.params.id, patientType: this.patientTypes[index].type })
      },
      clearPro() {
        this.addRecords.proRecords.records = []
        this.addRecords.proRecords.instructions = null
        this.$refs.proRecordDetails.clearPro()
        this.$emit('clearProRecords', { requestId: this.$route.params.id })
      },
      clearAllPatientType() {
        let message = 'Are you sure you want to clear all records?'
        this.$confirm(message, 'Clear All Records', {
          confirmButtonText: 'Clear All',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          for (let i = 0; i < this.addRecords.records.length; i++) {
            this.clearPatientType(i)
          }
          this.clearPro()
        }).catch(() => {
        })
      },
      setIndices() {
        this.ipIndex = this.patientTypes.findIndex(x => x.type === 'ip')
        this.drgIndex = this.patientTypes.findIndex(x => x.type === 'drg')
        this.ascIndex = this.patientTypes.findIndex(x => x.type === 'asc')
        this.obsIndex = this.patientTypes.findIndex(x => x.type === 'obs')
        this.ancIndex = this.patientTypes.findIndex(x => x.type === 'anc')
        this.edIndex = this.patientTypes.findIndex(x => x.type === 'ed')
        this.irIndex = this.patientTypes.findIndex(x => x.type === 'ir')
        this.wcIndex = this.patientTypes.findIndex(x => x.type === 'wc')
        this.pmIndex = this.patientTypes.findIndex(x => x.type === 'pm')
        this.otherIndex = this.patientTypes.findIndex(x => x.type === 'other')
      },
      totalReviewRecords() {
        if (this.addRecords.records.length === 0) {
          return this.getProRecordsCount()
        }

        let ip = (this.addRecords.records[this.ipIndex].records)
        let drg = (this.addRecords.records[this.drgIndex].records)
        let asc = this.addRecords.records[this.ascIndex].records
        let obs = this.addRecords.records[this.obsIndex].records
        let anc = this.addRecords.records[this.ancIndex].records
        let ed = (this.addRecords.records[this.edIndex].records + this.addRecords.records[this.edIndex].facility + this.addRecords.records[this.edIndex].professional + this.addRecords.records[this.edIndex].both)
        let ir = this.addRecords.records[this.irIndex].records
        let wc = this.addRecords.records[this.wcIndex].records
        let pm = this.addRecords.records[this.pmIndex].records
        let other = this.addRecords.records[this.otherIndex].records
        let pro = this.getProRecordsCount()

        return (ip + drg + asc + obs + anc + ed + ir + wc + pm + other + pro)
      },
      getReviewValidations(type) {
        return this.reviewValidations.filter(x => x.patientType === type)
      },
      addProRecords(payload) {
        this.addRecords.proRecords = payload.proRecords
        this.$emit('addProRecords', { requestId: this.$route.params.id, patientType: 'pro', records: this.addRecords.proRecords })
      },
      getProRecordsCount() {
        let length = this.addRecords.proRecords.records.length
        let proRecordsCount = 0
        let item
        if (length > 0) {
          for (let i = 0; i < length; i++) {
            item = this.addRecords.proRecords.records[i]
            proRecordsCount += (item.numProviders * item.numEM) + (item.numProviders * item.numCPT)
          }
        }
        return proRecordsCount
      },
      initRecords() {
        return new Promise((resolve, reject) => {
          this.recordSet = false
          let recordsExist = false
          // check if request exists; populate
          if (this.reviewRequest.records.length) {
            this.addRecords.records = this.reviewRequest.records
            recordsExist = true
          }
          if (this.reviewRequest.proRecords.records.length) {
            this.addRecords.proRecords = this.reviewRequest.proRecords
          }

          if (!recordsExist) {
            let length = this.patientTypes.length
            for (let i = 0; i < length; i++) {
              let reviewPatientTypeItem = {
                type: this.patientTypes[i].type,
                title: this.patientTypes[i].title,
                comprehensiveRecords: 0,
                aprDrg: false,
                poa: false,
                level2: false,
                drgRecords: 0,
                instructions: null,
                includePCS: false,
                records: 0,
                em: false,
                ii: false,
                recurringRecords: false,
                recurringAccount: null,
                facility: 0,
                professional: 0,
                both: 0,
                si: false,
                serviceInstructions: null,
                proem: false
              }
              this.addRecords.records.push(reviewPatientTypeItem)
            }
            return resolve()
          } else {
            return resolve()
          }
        })
      }
    },
    created() {
      this.setIndices()
      this.initRecords().then(() => {
        this.recordSet = true
      })
    },
    components: {
      ReviewRequestProRecordDetails
    },
    computed: {
      ...mapState('requests/reviews', ['reviewValidations'])
    }
  }
</script>
<style scoped>
  .recordTemplate {
    width: 100%;
    display: grid;
  }

  .hiaValidation {
    margin: 0px 0px 0px 0px;
    padding: 2px 5px 2px 5px;
    border: 1px solid rgba(238, 238, 238, 1);
    border-radius: 10px;
    background: rgba(238, 238, 238, .5);
  }

  .hiaValidation li {
    list-style-type: none;
  }

  .reviewHeading {
    margin: 12px 0px 0px 0px;
    border-bottom: 1px solid #c0c4cc;
    padding-bottom: 10px;
    line-height: 0;
  }

  /* REVIEW COLLAPSE */
  #reviewCollapse {
    /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1); */
    border-top: 1px solid #b4bccc;
    /* border-bottom: 1px solid #b4bccc; */
    /* border-radius: 5px; */
    /* border-right: 1px solid #b4bccc;
    border-left: 1px solid #b4bccc; */
  }

  #reviewCollapse>>>.el-collapse-item__header {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    border-bottom: 1px solid #b4bccc;
    /* border-top-left-radius: 5px;
    border-top-right-radius: 5px; */
    color: #606266;
    font-weight: 500;
  }

  #reviewCollapse>>>.el-collapse-item__header:hover {
    background-color: rgb(238, 238, 238);
  }

  #reviewCollapse>>>.el-collapse-item__wrap {
    border-bottom: 1px solid #b4bccc;
    /* border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px; */
  }

  #reviewCollapse>>>.el-collapse-item:last-child .el-collapse-item__header {
    /* border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px; */
  }

  #reviewCollapse>>>.el-collapse-item.is-active .el-collapse-item__header {
    background-color: rgb(238, 238, 238);
  }

  #reviewCollapse>>>div[aria-controls*="el-collapse-content-"] {
    background-color: rgb(238, 238, 238);
    /* border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px; */
  }

  #reviewCollapse>>>.el-collapse-item.is-active div[aria-controls*="el-collapse-content-"] {
    background-color: rgb(238, 238, 238);
    /* border-top-right-radius: 0px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px; */
  }

  #reviewCollapse>>>.el-form-item__label {
    font-size: 13px;
    padding: 0px 0px 0px 0px;
  }

  #reviewCollapse>>>.el-checkbox__label {
    font-weight: 400;
  }

  #reviewCollapse>>>.el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }

  .topPadding {
    padding: 10px 10px 0px 0px;
  }

  .subMargin {
    margin-left: 10px;
  }

  .totalRecords {
    font-size: 14px;
  }

  .contentSpacing {
    margin: 0px 0px 0px 0px !important;
    padding: 0px 0px 0px 0px !important;
  }

  .collapseContentLeft {
    padding: 5px 0px 8px 10px !important;
  }

  .collapseContentRight {
    padding: 5px 10px 8px 10px !important;
  }

  /* ICON STYLE */
  .reviewIcon {
    font-size: 17px;
    float: left;
    height: 12px;
    margin: -3px 5px 0px 0px;
  }

  /* ALERTS */
  #reviewCollapse>>>.el-alert__icon.is-big {
    font-size: 18px;
    width: 18px;
  }

  .additionalPricing {
    margin: 0px 0px 0px 5px;
  }
</style>
